import React, { useState } from 'react';
import {
  Card,
  Input,
  Button,
  Typography,
  Divider,
  message,
} from 'antd';
import {
  CloseOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import { SourcePanel } from '../../../types';
import { sourceStoriesApi } from '../../../services/api/sourceStories';

const { TextArea } = Input;
const { Title, Text } = Typography;

interface PanelCaptionEditorProps {
  storyId: string;
  panel: SourcePanel;
  onSuccess: (updatedPanel: SourcePanel) => void;
  onCancel: () => void;
}

const PanelCaptionEditor: React.FC<PanelCaptionEditorProps> = ({
  storyId,
  panel,
  onSuccess,
  onCancel,
}) => {
  const [caption, setCaption] = useState(panel.caption || '');
  const [loading, setLoading] = useState(false);

  const hasLocalizedCaption = !!panel.localizedCaption && panel.localizedCaption !== panel.caption;

  const handleSave = async () => {
    setLoading(true);
    try {
      const result = await sourceStoriesApi.updateSourcePanel(
        storyId,
        panel.sceneId,
        panel.id,
        { caption: caption.trim() }
      );

      message.success('Caption updated successfully');
      onSuccess(result.data);
    } catch (error: any) {
      console.error('Failed to update panel caption:', error);
      message.error(error.response?.data?.error || 'Failed to update caption');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      size="small"
      title={
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={5} style={{ margin: 0, fontSize: '14px' }}>Edit Caption</Title>
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onCancel}
            size="small"
          />
        </div>
      }
      style={{ marginBottom: 8, border: '1px solid #1890ff', borderRadius: 8 }}
    >
      <div style={{ marginBottom: 12 }}>
        <TextArea
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          placeholder="Enter panel caption..."
          autoSize={{ minRows: 3, maxRows: 8 }}
        />
        {hasLocalizedCaption && (
          <div style={{ marginTop: 4 }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              ℹ️ Đang sửa caption gốc (hiện có bản dịch riêng)
            </Text>
          </div>
        )}
      </div>

      <Button
        type="primary"
        icon={<SaveOutlined />}
        onClick={handleSave}
        loading={loading}
        block
        size="small"
      >
        Save Caption
      </Button>
    </Card>
  );
};

export default PanelCaptionEditor;
